<script lang="ts">
    import {browser} from '$app/environment';
    import {goto} from '$app/navigation';
    import LinearPreloader from '$lib/components/LinearPreloader.svelte';
    import {now} from '$lib/stores/now';
    import {debounce, getImageLink} from '$lib/utils';

    let query = '';
    let inputFocus = false;

    let data: Promise<SupplierShortItem[]> = Promise.resolve([]);

    let blurTimeout: any; // Задержка для обработки кликов
    function onInputBlur() {
        blurTimeout = setTimeout(() => {
            inputFocus = false;
        }, 200);
    }

    function onInputFocus() {
        !!blurTimeout && clearTimeout(blurTimeout);
        inputFocus = true;
    }

    const search_d = debounce(search, 100);
    $: browser && search_d(query);

    function search(q: string) {
        if (!q) {
            data = Promise.resolve([]);
            return;
        }

        data = new Promise((resolve, reject) => {
            fetch(`/api/catalog/fast-search?q=${encodeURIComponent(q)}&limit=3`)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error('Response is not 200');
                })
                .then(responseJson => {
                    resolve(responseJson);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    }

    function onClickFallback(
        e: Event & {
            currentTarget: EventTarget & HTMLElement;
        },
        url: string
    ) {
        if (blurTimeout) {
            !!blurTimeout && clearTimeout(blurTimeout);
            inputFocus = false;
        }

        // @ts-ignore
        if (e.target && e.target.tagName.toLowerCase() !== 'a') {
            goto(url);
        }
    }
</script>

<form action="/catalog" class="relative w-full">
    <input
        name="q"
        class="w-full px-4 py-2 border rounded border-gray"
        type="text"
        placeholder="Найти сайт..."
        on:blur={onInputBlur}
        on:focus={onInputFocus}
        bind:value={query}
    />

    {#if query && inputFocus}
        <div class="absolute left-0 right-0 z-10 mt-1 bg-white border divide-y rounded shadow-lg top-full border-gray">
            {#await data}
                <div class="p-4">
                    <LinearPreloader center />
                </div>
            {:then suppliers}
                {#each suppliers as supplier (supplier.id)}
                    {@const url = `/catalog/${supplier.slug}`}

                    <div
                        class="flex items-start p-4 transition-colors hover:bg-gray-50"
                        on:click={e => onClickFallback(e, url)}
                        aria-hidden="true"
                    >
                        <a class="w-10 mr-4 shrink-0" href={url} target="_blank">
                            <img class="block w-full" alt={supplier.title} src={getImageLink(supplier.logo, '40x40rtr')} />

                            {#if supplier.free_until > $now.ts}
                                <div class="item-flag">
                                    <div class="font-brand-bold text-green text-xxs">FREE</div>
                                </div>
                            {/if}
                        </a>

                        <div class="overflow-hidden grow">
                            <a
                                class="block overflow-hidden text-black font-brand-bold whitespace-nowrap text-ellipsis"
                                href={url}
                                target="_blank">{supplier.title}</a
                            >
                            <div class="overflow-hidden text-xs text-black-500 whitespace-nowrap text-ellipsis">
                                {supplier.website.domain}
                            </div>
                        </div>
                    </div>
                {:else}
                    <div class="p-4 text-center text-black-500">
                        Ничего не найдено<br />
                        <a href="/my/catalog/add">Заказать парсинг?</a>
                    </div>
                {/each}

                {#if suppliers.length > 0}
                    <a
                        class="block p-4 text-center transition-colors hover:no-underline hover:bg-gray-50"
                        href="/catalog?q={encodeURIComponent(query)}">Все результаты</a
                    >
                {/if}
            {:catch}
                <div class="p-4 text-sm text-center text-red">Ошибка поиска</div>
            {/await}
        </div>
    {/if}
</form>

<style lang="postcss">
    .item-flag {
        position: absolute;
        top: -6px;
        left: -8px;
        cursor: default;
        pointer-events: none;
        white-space: nowrap;
        background: #000;
        border-radius: 0 2px 2px 0;
        padding: 2px 6px 1px 7px;

        &:before {
            content: '';
            position: absolute;
            top: 100%;
            left: 0;
            width: 0;
            height: 0;
            border-style: solid;
            border-color: transparent var(--color-green) transparent transparent;
            border-width: 0 8px 8px 0;
        }
    }
</style>
